
import {
  BookOpen as BookOpenIcon,
  CheckSquare as CheckSquareIcon,
  List as ListIcon,
  Sliders as SlidersIcon,
} from "react-feather";

import { InventoryComponent as Inventory,
  EditProductTransactions
 } from "../pages/operations/inventory";

import { 
  NutritionPlanned,
  NutritionHistory} from "../pages/operations/nutrition";


import { 
    SprayPlannedList,
    EditSprayExecuted
  } from "../pages/operations/sprays";

import { useSessionStore } from "../services/stores";
import Calendar  from "../pages/dashboards/Calendar";
import Monitoring from "../pages/operations/monitoring";
import Default from "../pages/dashboards/Default";
import { SprayExecutedList } from "../pages/operations/sprays/SprayExecutedList";
import { InventoryTransactions } from "../pages/operations/inventory/InventoryTransactions";
import { FruitSize } from "../pages/operations/monitoring/FruitSize";

//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//  Bell as Bellicon,
//  Calendar as CalendarIcon,
//  Grid as GridIcon,
//  Heart as HeartIcon,
//  Layout as LayoutIcon,
//  MapPin as MapPinIcon,
//  Monitor as MonitorIcon,
//  PieChart as PieChartIcon,
//  Users as UsersIcon,
//  Barcode as BarcodeIcon,


//const Default = async(() => import("../pages/dashboards/Default"));
//const Calendar = async(() => import("../pages/dashboards/Calendar"));
//const Inventory = async(() => import("../pagesoperations/inventory/inventory"));
//const Monitoring = async(() => import("../pages/operations/monitoring"));
//const Nutrition = async(() => import("../pages/operations/nutrition/nutritionPlanned"));
//const Sprays = async(() => import("../pages/operations/sprays"));

import { MainMenu } from "../pages/landing/MainLandingPage";

// Routes
//
const landingRoutes = {
  path: "/",
  name: "Landing Page",
  component: MainMenu,
};

const dashboardRoutes = {
  path: "/dashboard",
  name: "Tableaus de bord",
  header: "Tableau de bord",
  badgeColor: "primary",
  badgeText: "5",
  icon: SlidersIcon,
  containsHome: true,
  hidden: false,
  children: [    
    {
      path: "/dashboard/default",
      name: "Etat des cultures",
      component: Default,
      hidden: false,
    },
  ]
};

const productsRoutes = {
  path: "/products",
  name: "Inventaire",
  header: "Etat actuel",
  badgeColor: "primary",
  badgeText: useSessionStore.getState().productCount,
  icon: ListIcon,
  containsHome: true,
  hidden: false,
  children: [    
    {
      path: "/products/inventory",
      name: "Produits",
      icon: ListIcon,
      component: Inventory,
      badgeText: "888",
      hidden: false
    },
    {
      path: "/products/inventory/transactions",
      name: "Mouvements de stock",
      component: InventoryTransactions,
      hidden: false
    },
    {
      path: "/products/inventory/product-transactions",
      name: "Mouvements de stock sur un produit",
      component: EditProductTransactions,
      hidden: true
    }
 ]
};

const spraysRoutes = {
  path: "/sprays",
  name: "Traitements",
  badgeColor: "primary",
  badgeText: "15",
  icon: BookOpenIcon,
  header: "Traitements",
  hidden: false,
  children: [    
    {
      path: "/sprays",
      name: "Traitements",
      icon: CheckSquareIcon,
      component: SprayPlannedList,
      hidden: false,
    },

  ]
};

const nutritionRoutes = {
  path: "/fertigation",
  name: "Nutrition",
  badgeColor: "primary",
  badgeText: "15",
  icon: BookOpenIcon,
  hidden: false,
  children: [    
    {
      path: "/fertigation",
      name: "Fertigation",
      component: NutritionPlanned,
      hidden: false,
    }
  ]
};

const monitoringRoutes = {
  path: "/monitoring",
  name: "Supervision",
  badgeColor: "primary",
  badgeText: "15",
  icon: BookOpenIcon,
  header: "Supervision",
  hidden: false,
  children: [    
    {
      path: "/monitoring/fruit-size",
      name: "Calibre des fruits",
      component: FruitSize,
      hidden: false,
    },
    {
      path: "/monitoring/calibre",
      name: "Calibre",
      component: Monitoring,
      hidden: false,
    },
    {
      path: "/monitoring/stades",
      name: "Stades phenologiques",
      component: Monitoring,
      hidden: false,
    },
  ]
};


// Dashboard specific routes
//
export const dashboard = [
  dashboardRoutes,
];

// Landing specific routes
//
export const landing = [
  landingRoutes
];

// Operations specific routes
//
export const operations = [
    productsRoutes, 
    spraysRoutes,   
    nutritionRoutes, 
    monitoringRoutes,
    ];
